import { useCallback, useState } from "react";
import { Col, Container, Dropdown, Row } from "react-bootstrap";
import TableLayout from "../../../../components/TableLayout";
import { CommonSelect, CstmPagination } from "../../../../components/Common/Common";
import { useNavigate } from "react-router-dom";
import { HOME_EDUCATION_CLIENT_DETAIL } from "config/paths";
import { useGetHomeEducationListQuery, useUpdateHomeEducationClientMutation } from "store/services/clients/homeEducation";
import LoadingIndicator from "components/shared/LoadingIndicator";
import moment from "moment";
import TableHeader from "components/shared/FormComponents/TableHeader";
import LoadingOverlay from "components/shared/LoadingOverlay";
import ErrorComponent from "components/shared/ErrorComponent";
import { dateFormat } from "helpers/common";
import ClientsReportMenu from "components/shared/ReportComponents/ClientsReportMenu";
import { useClientsServiceStatusListQuery } from "store/services/utility";
import { CLIENT_STATUS_OPTION, CLIENT_TYPE_KEYS, GRADE_OPTIONS, HOME_CLIENT_STATUS_OPTION } from "config/constants";
import ServiceStatusUpdateField from "../Components/ServiceStatusUpdateField";
import { useDispatch, useSelector } from "react-redux";
import { homeEducationClientsFilter, initialFilterState } from "store/slices/filter";
import { usePersistentState } from "hooks/usePersistentState";
import TableLayoutV2 from "components/TableLayoutV2";
import { Star } from "react-feather";
import { useFavouriteSchoolClientMutation } from "store/services/clients/school.client";
import { debounce } from "lodash";

const HomeEducation = () => {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = usePersistentState("home-ed:page", 1);
  const [pageSize, setPageSize] = useState(10);
  const filter = useSelector(state => state?.filter?.homeEducationClientsFilter);
  console.log("filterfilter", filter);

  const { data, isLoading, isError, isFetching, refetch } = useGetHomeEducationListQuery({ page: currentPage, limit: pageSize, ...filter });
  const totalRecords = data?.totalRecords || 0;
  const totalPages = Math.ceil(totalRecords / pageSize);
  const [favouriteClient, { isLoading: favouriteClientLoading }] = useFavouriteSchoolClientMutation()

  const [updateClient, { isLoading: updateClientLoading }] = useUpdateHomeEducationClientMutation();

  const { data: serviceStatusList, isLoading: serviceStatusListLoading } = useClientsServiceStatusListQuery({ module: "client_service", client_type: 'home_education' });
  const serviceStatusOptions = serviceStatusList?.map(i => ({ value: i.id, label: i.title }));

  const handleFavouriteClient = async (id, favorite) => {
    const data = {
      favorite
    }
    try {
      await favouriteClient({ data, id }).unwrap()
      refetch();
    } catch (error) {
      console.log('error making the client favourite: ', error)
    }
  }


  const column = [
    {
      head: <div onClick={() => dispatch(homeEducationClientsFilter({ ...filter, sort: filter?.sort?.column == "is_favorite" ? { column: "lastname", direction: "ASC" } : { column: "is_favorite", direction: "desc" } }))}>{filter?.sort?.column == "is_favorite" ? <Star fill="#93278F" stroke="#93278F" width={18} /> : <Star width={18} stroke="#8F8F8F" />}</div>,
      accessor: "is_favorite",
      isComponent: true,
      component: (item, ind) => (
        <h6 className="m-0 text-capitalize d-flex align-items-center gap-2"><div className="cursor-pointer" onClick={(e) => { e.stopPropagation(); handleFavouriteClient(item?.client_detail?.id, item?.client_detail?.is_favorite ? 0 : 1) }}>{item?.client_detail?.is_favorite ? <Star fill="#93278F" stroke="#93278F" width={18} /> : <Star width={18} stroke="#8F8F8F" />}</div></h6>
      ),
    },
    {
      head: "Last Name",
      accessor: "lastname",
      isComponent: true,
      sorter: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-sbold text-capitalize">{item.lastname}</h6>
      ),
    },
    {
      head: "First Name",
      accessor: "firstname",
      sorter: true,
      isComponent: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-sbold text-capitalize">{item.firstname}</h6>
      ),
    },
    {
      head: "DOB",
      accessor: "dob",
      sorter: true,
      isComponent: true,
      component: (item, ind) => (
        <>{item?.client_detail?.dob ? moment(item?.client_detail?.dob).format("DD/MM/YYYY") : "--"}</>
      ),
    },
    {
      head: <div className="w-100 text-center">Grade</div>,
      accessor: "grade",
      sorter: true,
      component: (item, ind) => <div className="w-100 text-center">{item?.client_detail?.grade || "--"}</div>,
    },
    // {
    //   head: "Education Authority",
    //   accessor: "EducationAuthority",
    //   isComponent: true,
    //   component: (item, ind) => (
    //     <>{item?.client_detail?.client_home_education_detail?.education_authority || "--"}</>
    //   ),
    // },
    // Removed by client
    // {
    //   head: "Date of intake",
    //   accessor: "intakeDate",
    // },
    {
      head: "Date of intake",
      accessor: "intakeDate",
      // sorter: true,
      component: (item) => dateFormat(item?.client_detail?.client_home_education_detail?.intake_date, "MMM DD, YYYY"),
    },
    {
      head: "Disciplines",
      accessor: "disciplines",
      component: (item, ind) => (
        <>
          <div>
            {
              item?.clientPendingCaseload?.clientCaseloadTherapist?.map((therapist, index) => <span className={`discipline-${therapist?.caseDiscipline?.assign_term}-capsule-bcg`} style={{ padding: "7px 10px", marginRight: "3px", borderRadius: "8px" }}>{therapist?.caseDiscipline?.assign_term}</span>)
            }
          </div>
        </>
      ),
    },
    {
      head: "Account Status",
      accessor: "status",
      sorter: true,
      component: (item, ind) => (
        <div style={{ color: item?.status == "active" && '#55A215', fontStyle: ["inactive", 'discharged']?.includes(item?.status) && "italic" }} className="text-capitalize">
          {(item?.status || "--")}
        </div>
      ),
    },
    // {
    //   head: "Service Assigned",
    //   accessor: "FirstName",
    //   isComponent: true,
    //   component: (item, ind) => (
    //     <div>Workshop</div>
    //   ),
    // },
    // {
    //   head: <div className="w-100 text-center">Service Status</div>,
    //   accessor: "BudgetAssigned",
    //   isComponent: true,
    //   component: (item, ind) => {
    //     const selectedStatus = item?.client_detail?.service_status
    //       ? serviceStatusOptions?.find(x => x.value === item.client_detail.service_status)
    //       : null;
    //     return (
    //       <div className="w-100 text-center">
    //         {selectedStatus ? selectedStatus.label : "Not Assigned"}
    //       </div>
    //     )
    //     //  <CommonSelect
    //     //       placeholder={"Not Assigned"}
    //     //       option={serviceStatusOptions}
    //     //       isLoading={serviceStatusListLoading}
    //     //       onChange={(status) => handleUpdateClient("service_status")(status.value) }
    //     //       value={item?.client_detail?.service_status ? serviceStatusOptions?.find(x => x.value === item?.client_detail?.service_status) : null}
    //     //     />       
    //     // <ServiceStatusUpdateField
    //     //   clientDetails={item}
    //     //   updateClient={updateClient}
    //     //   clientType={CLIENT_TYPE_KEYS.home_education}
    //     // />
    //   },
    // },
    {
      head: "Action",
      accessor: "",
      isComponent: true,
      component: (item, index) => (
        <ClientsReportMenu
          v2={true}
          index={index}
          client={item}
        />
      ),
    },
  ];

  const resetFilter = () => {
    dispatch(homeEducationClientsFilter(initialFilterState.homeEducationClientsFilter));
    setCurrentPage(1)
  };

  const handlePageChange = (page) => {
    window.scrollTo(0, 0);
    setCurrentPage(page);
  };

  const handleFilterChange = (key) => (value) => {
    dispatch(homeEducationClientsFilter({ ...filter, [key]: value }))
    setCurrentPage(1); // Reset to first page when filter changes
  };

  const handleSearchChange = useCallback(debounce((value) => {

    handleFilterChange("search")(value);

  }, 500), [handleFilterChange, 500]);


  return (
    <>
      {" "}
      <section className="client position-relative py-4">
        <Container fluid>
          {
            isLoading ? <LoadingIndicator /> : <Row>
              <Col lg="12" className="my-2">
                <div className="left classroom-conslutation">
                  <h6 className="m-0 fw-bold main-head themeBlue">Home Education</h6>
                </div>
                {/* <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
                  <div className="left"> */}
                {/* <TableHeader
                      heading={"Home Education Caseload"}
                      handleFilterChange={handleFilterChange}
                      filter={filter}
                      resetFilter={resetFilter}
                      searchPlaceholder="Client First, Last Name"
                    /> */}
                <Row className="reports-v2 my-3 d-flex justify-content-end classroom-conslutation">
                  <Col md='4'>
                  </Col>
                  <Col md='2'>
                    <div className="d-flex w-100 align-items-center gap-3">
                      <label className="discharge-screen-label mb-0">Grade</label>
                      <CommonSelect
                        placeholder={"Select"}
                        option={GRADE_OPTIONS}
                        onChange={(e) => handleFilterChange("grade")(e)}
                        value={filter?.grade}
                        // onInputChange={(val) => handleSearch(val)}
                        isFilterV2
                        isClearable
                        styles={{
                          container: (provided) => ({
                            ...provided,
                            width: "100%", // ✅ Ensures the whole Select container is full width
                          }),
                        }}
                      // isLoading={schoolsLoading}
                      />
                    </div>
                  </Col>
                  <Col md='2'>
                    <div className="d-flex w-100 align-items-center gap-3">
                      <label className="discharge-screen-label mb-0">Status</label>
                      <CommonSelect
                        placeholder={"Select"}
                        option={HOME_CLIENT_STATUS_OPTION}
                        onChange={(e) => handleFilterChange("status")(e)}
                        value={filter?.status}
                        isFilterV2
                        // isClearable
                        // isLoading={schoolListLoading || schoolListFetching}
                        styles={{
                          container: (provided) => ({
                            ...provided,
                            width: "100%", // ✅ Ensures the whole Select container is full width
                          }),
                        }}
                      />
                    </div>
                  </Col>
                  <Col lg="4">
                    <div className="d-flex w-100 align-items-center gap-3">
                      <label className="discharge-screen-label mb-0">Search</label>
                      <input
                        onChange={(e) => handleSearchChange(e.target.value)}
                        className={` readonly-box h-auto search-input-filter-v2`}
                        placeholder="Type..."
                        defaultValue={filter?.search}
                      />
                    </div>
                  </Col>
                </Row>
                {/* </div> */}

                {/* </div> */}

                <div className="table-outer">
                  {isLoading ? (
                    <div style={{ height: "200px" }}>
                      <LoadingIndicator />
                    </div>
                  ) : isError ? (
                    <ErrorComponent />
                  ) : (
                    <>
                      {(isFetching || favouriteClientLoading) && <LoadingOverlay />}
                      <TableLayoutV2
                        data={data?.records || []}
                        column={column}
                        url={HOME_EDUCATION_CLIENT_DETAIL.replace("/:id", "")}
                        handleSort={handleFilterChange("sort")}
                        filter={filter}
                      />
                    </>
                  )}
                  <CstmPagination
                    totalPages={totalPages}
                    activePage={currentPage}
                    className={'paginationV2'}
                    handlePageChange={handlePageChange}
                  />
                </div>
              </Col>
            </Row>
          }
        </Container>
      </section>
    </>
  );
};

export default HomeEducation;
